import React, { useState, useEffect } from 'react'
import './App.css';
import styled from 'styled-components';
import { BotonDisminuir, BotonIncrementar, BotonCheck, BotonGenerar } from './componentes/botones';
import generarPassword from './helpers/generarPassword';

function App() {

    // Declarar el state cuando inicie la aplicacion
    const [configuracion, cambiarConfiguracion] = useState({
        numeroCaracteres: 7,
        simbolos: true,
        numeros: true,
        mayusculas: true
    });

    // Declarar un state para la contraseña
    const [passwordGenerada, cambiarPasswordGenerada] = useState('');

    // Declarar el useEffect
    useEffect(() => {
        cambiarPasswordGenerada( generarPassword(configuracion) );
    }, [configuracion]);

    // Funcion que incrementara el numero de caracteres
    function incrementarNumeroCaracteres() {
        cambiarConfiguracion( (objetoAnterior)  => {
            const objetoNuevo = {...objetoAnterior};
            objetoNuevo.numeroCaracteres +=1;
            return objetoNuevo;
        });
    }

    // Funcion que disminuye el numero de caracteres
    function disminuirNumeroCaracteres() {
        if (configuracion.numeroCaracteres > 1) {
            cambiarConfiguracion( (objetoAnterior)  => {
                const objetoNuevo = {...objetoAnterior};
                objetoNuevo.numeroCaracteres -=1;
                return objetoNuevo;
            });
        }
    }

    // Funciones que cambia la configuracion de los botones
    function toggleSimbolos() {
        cambiarConfiguracion( (objetoAnterior)  => {
            const objetoNuevo = {...objetoAnterior};
            objetoNuevo.simbolos = !objetoNuevo.simbolos;
            return objetoNuevo;
        });
    }

    function toggleNumeros() {
        cambiarConfiguracion( (objetoAnterior)  => {
            const objetoNuevo = {...objetoAnterior};
            objetoNuevo.numeros = !objetoNuevo.numeros;
            return objetoNuevo;
        });
    }

    function toggleMayusculas() {
        cambiarConfiguracion( (objetoAnterior)  => {
            const objetoNuevo = {...objetoAnterior};
            objetoNuevo.mayusculas = !objetoNuevo.mayusculas;
            return objetoNuevo;
        });
    }

    // Funcion para prevenir que se recargue la pagina al dar click en el boton del formulario
    function onSubmit(e) {
        e.preventDefault();
        cambiarPasswordGenerada( generarPassword(configuracion) );
    }

    return(
        <div className='contenedor'>
            <h1 className='nombre'>generador de contraseñas</h1>

            <form onSubmit={onSubmit}>
                <Fila>
                    <label>Numero de caracteres: </label>
                    <Controles>
                       <BotonDisminuir click={disminuirNumeroCaracteres} /> 
                            <span>{configuracion.numeroCaracteres}</span>
                        <BotonIncrementar click={incrementarNumeroCaracteres} />
                    </Controles>
                </Fila>
                <Fila>
                    <label>¿Incluir Simbolos?</label>
                    <BotonCheck seleccionado={configuracion.simbolos} click={toggleSimbolos} />
                </Fila>
                <Fila>
                    <label>¿Incluir Numeros?</label>
                    <BotonCheck seleccionado={configuracion.numeros} click={toggleNumeros} />
                </Fila>
                <Fila>
                    <label>¿Incluir Mayusculas?</label>
                    <BotonCheck seleccionado={configuracion.mayusculas} click={toggleMayusculas} />
                </Fila>
                <Fila>
                    <BotonGenerar />
                    <Input type="text" readOnly={true} value={passwordGenerada} />
                </Fila>
            </form>
        </div>
    );
    
}


export default App;

// Trabajando con styled components
const Fila = styled.div `
    margin-bottom: 40px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
`;

const Controles = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;

    & > * {
        flex: 1;
    }

    span {
        line-height: 40px;
        background-color: #33257E;
    }
`;

const Input = styled.input `
    width: 100%;
    background: none;
    border-radius: 4px;
    border: 1px solid rgba(255,255,255, .25);
    color: #ffffff;
    line-height: 40px;
    height: 40px;
    cursor: pointer;
    transition: all .3s ease;

    &:hover {
        border: 1px solid rgba(255,255,255, .50);
    }
    &::selection {
        background-color: #212139;
    }
`;

